export const getFieldProperties = (field, tipoCadastro, tempValues) => {
    const type = tipoCadastro?.value;

    if (field === "go" || field === "porte") {
        if (type === "UNIDADE") {
            // Unidade: campos habilitados
            return {
                isDisabled: false,
                placeholder: tempValues[field] || "Selecione uma opção",
            };
        } else if (type === "GERENCIA") {
            // Gerência: campos desabilitados
            return {
                isDisabled: true,
                placeholder: "Campo desabilitado para Gerência",
            };
        }
    }

    const fieldLabels = {
        nome: type === "UNIDADE" ? "Nome da Unidade" : "Nome da Gerência",
        sigla: type === "UNIDADE" ? "Sigla da Unidade" : "Sigla da Gerência",
        numero: type === "UNIDADE" ? "Número da Unidade" : "Número da Gerência",
    };

    return {
        isDisabled: !tipoCadastro,
        placeholder: fieldLabels[field] || "Campo desabilitado",
        label: fieldLabels[field] || field,
    };
};
